import { TerminalImportLogDtoToEntity } from "src/app/features/TerminalImportLog/services/mappers/TerminalImportLogDtoToEntity";
import type { TerminalImportLogDto } from "src/app/features/TerminalImportLog/types/TerminalImportLogDto";
import type { TerminalImportLogEntity } from "src/app/features/TerminalImportLog/types/TerminalImportLogEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const TerminalImportLogTableDtoMapper = (
    input: Readonly<ResourcePageDto<TerminalImportLogDto>>,
): ResourcePageEntity<TerminalImportLogEntity> => {
    return {
        list: input.list ? input.list.map(TerminalImportLogDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
